import React from "react";

const Iframe = ({ htmlCode }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlCode }}></div>;
};

export default Iframe;
